import {
  CommonActions,
  RouteProp,
  useFocusEffect,
  useNavigation,
  useRoute,
} from '@react-navigation/native'
import React, { useContext, useEffect, useState } from 'react'
import { LogisticsRoutes, RootParams } from '../../../../../navigator/types'
import { TakePhoto } from '../../../../../components/TakePhoto'
import { AlertMessage } from '../../../../../components/AlertMessage'
import { StackNavigationProp } from '@react-navigation/stack'
import { FuelContext } from '../../../../../context/Logistics/fuel/FuelProvider'
import { BodyAlert } from '../../components/BodyAlert'

export const InitialPhotoRod = () => {
  const { handleTakePhoto, handleSaveRecord, handleResetForm, form } = useContext(FuelContext)
  const navigation = useNavigation<StackNavigationProp<LogisticsRoutes, 'InitialPhotoRod'>>()
  const rootNavigation = useNavigation<StackNavigationProp<RootParams>>()
  const route = useRoute<RouteProp<LogisticsRoutes, 'InitialPhotoRod'>>()
  const [show, setShow] = useState({
    alert: false,
    camera: true,
  })

  const [photo, setPhoto] = useState('')

  const handleNavigate = (skipPhoto?: boolean) => {
    handleTakePhoto({ type: 'initialPhotoRod', uri: photo })
    setShow({
      alert: false,
      camera: false,
    })
    navigation.navigate(
      route.params?.returnToSummary ? 'Summary' : skipPhoto ? 'InitialPhotoMeter' : 'FinalPhotoRod',
    )
  }

  const handlePause = () => {
    handleSaveRecord({ ...form, stateForm: 'in-progress' })
    handleResetForm()
    rootNavigation.dispatch(CommonActions.reset({ index: 0, routes: [{ name: 'HomeScreen' }] }))
  }

  useFocusEffect(
    React.useCallback(() => {
      setShow({
        alert: false,
        camera: true,
      })
    }, []),
  )

  useEffect(() => {
    if (route.params) {
      setShow({
        alert: true,
        camera: false,
      })
      setPhoto(route.params.uri)
    }
  }, [route.params])

  return (
    <>
      {show.camera && (
        <TakePhoto
          getPhoto={(uri) => {
            setPhoto(uri)
            setShow({
              alert: true,
              camera: false,
            })
          }}
          capturingText='FOTO VARILLA INICIAL'
          indicationsText='Sitúe punta de la varilla dentro del margen'
          skipBtn={{
            show: true,
            action() {
              setShow({
                alert: false,
                camera: false,
              })
              handleNavigate(true)
            },
          }}
          pauseBtn={{ show: true, action: handlePause }}
        />
      )}

      {show.alert && (
        <AlertMessage
          title=''
          cancelLabel='Repetir foto'
          successLabel='Continuar'
          action={handleNavigate}
          cancelButton
          style={{ position: 'absolute' }}
          actionCancelButton={() => setShow({ alert: false, camera: true })}
        >
          <BodyAlert
            uri={photo}
            title='Foto tomada con éxito'
            desc={
              'Inserta la varilla seca dentro del estanque de combustible, espera 15 segundos y presiona continuar para tomar la siguiente foto.'
            }
            onClose={() => setShow({ alert: false, camera: true })}
          />
        </AlertMessage>
      )}
    </>
  )
}
